import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Senior Software Engineer with 6+ years of experience designing, building,
            and delivering production software across backend systems, cloud
            infrastructure, and AI-powered applications. Experienced in microservice
            architecture, AWS, third-party integrations, and engineering team
            leadership, with hands-on experience integrating AI capabilities and
            building MCP-based AI integrations. Focused on AI-first engineering,
            translating business requirements into practical, reliable solutions
            through software development, system integration, and production delivery.
          </p>
          <p style={{ textAlign: "justify" }}>
            I am currently employed as a senior software engineer at Burqup and hold
            a Master&apos;s degree in Computer Science from COMSATS Lahore.
          </p>
          <p>Apart from coding, I enjoy:</p>
          <ul>
            <li className="about-activity">
              <ImPointRight /> Cricket
            </li>
            <li className="about-activity">
              <ImPointRight /> Table Tennis
            </li>
            <li className="about-activity">
              <ImPointRight /> Learning New Techs
            </li>
          </ul>

          <p className="about-quote">
            "Explore yourself to serve better!"{" "}
          </p>
          <footer className="blockquote-footer">Rehman Akram</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
